import splashAnimation from "./assets/lottie/splashAnimation";

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

const illustration = {
  animated: true
};

const greeting = {
  username: "Vivek Shah",
  title: "Vivek Shah",
  role: "Founding Backend Engineer",
  subTitle:
    "Backend engineering lead at an AI-first startup — built the entire backend from zero, shipped production agentic pipelines, and designed systems that real B2B customers depend on.",
  resumeLink: "https://the-cipher-vivek-resume.vercel.app/resume.pdf",
  displayGreeting: true
};

const socialMediaLinks = {
  github: "https://github.com/Vivek-C-Shah",
  linkedin: "https://linkedin.com/in/the-cipher-vivek",
  gmail: "vivekchiragshah2004@gmail.com",
  display: true
};

const skillsSection = {
  title: "Tech Stack",
  skillGroups: [
    {
      label: "Languages",
      skills: ["Python", "TypeScript", "JavaScript", "Bash", "SQL"]
    },
    {
      label: "Backend",
      skills: [
        "FastAPI",
        "Node.js",
        "Express.js",
        "Flask",
        "gRPC",
        "Socket.io",
        "Celery",
        "BullMQ"
      ]
    },
    {
      label: "Frontend",
      skills: ["React", "Next.js", "Redux", "Zustand"]
    },
    {
      label: "DevOps & Infra",
      skills: [
        "Docker",
        "AWS",
        "Azure",
        "GCP",
        "MongoDB",
        "PostgreSQL",
        "Redis",
        "Firebase",
        "Linux"
      ]
    },
    {
      label: "AI / ML",
      skills: [
        "RAG Pipelines",
        "Vector Search",
        "Agentic Workflows",
        "OpenAI APIs",
        "MCP Servers",
        "Pinecone"
      ]
    }
  ],
  display: true
};

const educationInfo = {
  display: false,
  schools: [
    {
      schoolName: "Pandit Deendayal Energy University",
      logo: require("./assets/images/unilogo.png"),
      subHeader:
        "Bachelor of Technology in Information and Communication Technology",
      duration: "July 2021 – 2025"
    }
  ]
};

const techStack = {
  viewSkillBars: false,
  experience: [],
  displayCodersrank: false
};

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Founding Backend Engineer",
      company: "Pipeline, TechStack",
      date: "July 2024 – Present · Remote, India",
      desc: "Built the entire backend platform from zero. Full ownership of architecture, data models, and API contracts — no tech lead above me.",
      descBullets: [
        "Improved system throughput by 80% with Python-based services and API-first AI workflows",
        "Redis/BullMQ async queues handling 500+ concurrent jobs for 100+ active users",
        "LLM-powered agentic automation pipelines — improved B2B lead accuracy by 30%",
        "Direct CRM integrations: HubSpot, Salesforce, Apollo",
        "Production RAG pipelines, vector search (Pinecone), agentic workflows"
      ]
    },
    {
      role: "Full-Stack Developer Intern",
      company: "Reverr",
      date: "Apr 2024 – Jul 2024 · Remote, India",
      desc: "Built AI-powered workforce agents and real-time integrations.",
      descBullets: [
        "Built AI-powered workforce agents using TypeScript + OpenAI",
        "WhatsApp integration via Meta API",
        "Pinecone for contextual vector search"
      ]
    },
    {
      role: "SDE Intern",
      company: "Devobase",
      date: "May 2024 – Jul 2024 · Remote, India",
      desc: "Built subscription and customer management platform for Zeiirman Trading.",
      descBullets: [
        "Migrated 650+ user database",
        "Integrated Stripe, TradingView API, Discord bot",
        "Cut manual tasks by 70% with automated workflows"
      ]
    }
  ]
};

const bigProjects = {
  title: "Projects",
  subtitle:
    "Selected work. Most production work at Pipeline is under NDA.",
  projects: [
    {
      projectName: "Bookmark CE — AI-Native SaaS Backend",
      projectDesc:
        "Production SaaS that ingests web and cloud documents, runs semantic retrieval workflows, and enforces subscription-based feature access at scale. Hybrid dense + BM25 search with Reciprocal Rank Fusion, Razorpay billing with saga patterns and distributed locking, Google Drive and Notion OAuth integrations. Deployed as separate Dockerized Cloud Run services via GitHub Actions CI/CD.",
      stack: [
        "Python",
        "FastAPI",
        "PostgreSQL",
        "Redis",
        "Pinecone",
        "Docker",
        "GCP",
        "Razorpay",
        "OpenAI"
      ],
      footerLink: [
        {
          name: "Website",
          url: "https://bookmarkce.io/"
        }
      ]
    },
    {
      projectName: "In-House Redis",
      projectDesc:
        "Open-source Redis CLI built entirely from scratch in TypeScript. Implements stacks, queues, linked lists, streams, Pub/Sub messaging, RDBMS persistence, server replication (REPLCONF, PSYNC), and full transactional support.",
      stack: ["TypeScript", "Systems Design", "Data Structures"],
      footerLink: [
        {
          name: "GitHub",
          url: "https://github.com/Vivek-C-Shah/Redis-CLI-TypeScript"
        },
        {
          name: "Medium",
          url: "https://medium.com/@vivekchiragshah2004/building-a-redis-like-server-with-typescript-a-journey-of-learning-and-implementation-457fb289c288"
        }
      ]
    },
    {
      projectName: "MathScribe — Smart Math Notes",
      projectDesc:
        "AI-powered solver for math and physics problems from hand-drawn sketches. Client-server architecture with image processing + LLMs.",
      stack: ["Python", "FastAPI", "LLM", "Image Processing"],
      footerLink: [
        {
          name: "Live Demo",
          url: "https://math-scribe.vercel.app/"
        },
        {
          name: "Medium",
          url: "https://medium.com/@vivekchiragshah2004/mathscribe-a-dynamic-whiteboard-based-math-physics-solver-209b4a114e89"
        }
      ]
    },
    {
      projectName: "Isolated Falcon",
      projectDesc:
        "Offline LLM tool that summarizes PDFs and enables contextual chat without internet. Fine-tuned language model built entirely for edge deployment. SIH Finals — Top 5 of 44,000 teams.",
      stack: ["Python", "LLM Fine-tuning", "RAG", "Offline AI"],
      footerLink: [
        {
          name: "Demo",
          url: "https://youtu.be/ewbwI3p6K6c"
        }
      ]
    }
  ],
  display: true
};

const achievementSection = {
  title: "Awards & Recognition",
  awards: [
    {
      emoji: "🏆",
      title: "Winner — IDE Bootcamp 2024",
      description: "AICTE + Ministry of Education, Government of India"
    },
    {
      emoji: "🚀",
      title: "Startup Incubated — PDEU IIC",
      description: "Selected for funding at PDEU's Innovation and Incubation Centre"
    },
    {
      emoji: "🏅",
      title: "SIH Finalist — Smart India Hackathon",
      description: "Top 5 of 44,000 teams nationwide"
    },
    {
      emoji: "🎯",
      title: "Finalist — SSIP, Dotslash 6.0, Tic-Tech-Toe",
      description: "Multiple national-level hackathon finals"
    }
  ],
  display: true
};

const blogSection = {
  title: "Writing & Build Notes",
  subtitle:
    "Short technical essays, backend notes, and selected Medium posts. Drafts stay private until you publish them.",
  intro:
    "Custom notes are stored in MongoDB and Medium posts are imported into the same public feed so the section feels unified.",
  displayMediumBlogs: "true",
  mediumUsername: "vivekchiragshah2004",
  blogs: [],
  display: true,
  navLabel: "Writing",
  adminRoute: "/admin"
};

const talkSection = {
  title: "TALKS",
  subtitle: "",
  talks: [],
  display: false
};

const podcastSection = {
  title: "Podcast",
  subtitle: "",
  display: false
};

const contactInfo = {
  title: "Get in Touch",
  subtitle:
    "Open to remote backend roles, freelance, and interesting problems.",
  email_address: "vivekchiragshah2004@gmail.com"
};

const twitterDetails = {
  userName: "ShVivek25",
  display: false
};

const isHireable = true;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
